var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2700_10142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2794 1.76866L14.3054 12.1427L21.4576 12.1663L11.7215 26.2293L13.6964 14.8167L6.54412 14.7913L16.2794 1.76866ZM16.2802 0.0195312C16.233 0.0195312 16.1857 0.0212812 16.1394 0.0247812C15.8305 0.0492812 15.6257 0.153406 15.3834 0.316156C15.2486 0.405406 15.1252 0.515656 15.0167 0.642531C14.9844 0.680156 14.9546 0.719531 14.9266 0.759781L5.12049 13.7378C4.73374 14.2689 4.67599 14.9689 4.97349 15.5543C5.27099 16.1397 5.87124 16.5107 6.53012 16.5159L11.5815 16.5527L9.99337 25.9099C9.84287 26.714 10.2716 27.5155 11.0259 27.8384C11.2507 27.9347 11.487 27.981 11.7197 27.981C12.2701 27.981 12.7216 27.7238 13.0611 27.2592L22.8786 13.1962C23.2654 12.665 23.3222 11.9642 23.0256 11.3797C22.7281 10.7943 22.1279 10.4233 21.469 10.4189L16.4176 10.4102L17.9891 2.18341C18.0224 2.05128 18.039 1.91391 18.039 1.77216C18.039 0.825406 17.2856 0.0536563 16.3424 0.0230313C16.3214 0.0221563 16.3012 0.0221563 16.2802 0.0221563V0.0195312Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2700_10142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon-energy.ee27b42a34a514c873725b84449a3b16.svg";
export { ForwardRef as ReactComponent };